export enum ResidencyType {
  Tenant = "Tenant",
  Owner = "Owner",
}
